import React from "react"
import {UserDetails} from "components/backoffice/User/Details/UserDetails"

export const UserAddRoute = () => {

  return <div className="user-add-route-container">
    <h1>Ajouter un utilisateur</h1>
    <UserDetails userId={null} open={true} />
  </div>
}